import styled, { keyframes } from 'styled-components';
import { colors } from '@omilia/theme';

const pulse = keyframes`
  0% {
    opacity: 1;
  }
  50% {
    transform: scale(1.05);
  }
  100% {
    transform: scale(1);

  }
`;

const badgePulse = keyframes`
  0% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.1);
    opacity: 0.9;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
`;

const badgeRipple = keyframes`
  0% {
    transform: translate(-50%, -50%) scale(1);
    opacity: 0.8;
  }
  50% {
    transform: translate(-50%, -50%) scale(1.8);
    opacity: 0.3;
  }
  100% {
    transform: translate(-50%, -50%) scale(2.5);
    opacity: 0;
  }
`;

export const SBubbleIcon = styled.button<{
  showPulseEffect: boolean;
  previewMode?: boolean;
}>`
  animation: ${({ showPulseEffect }) => (showPulseEffect ? pulse : 'none')} 2s
    infinite;
  background: inherit;
  border-radius: 50%;
  border: none;
  bottom: ${({ previewMode }) => (previewMode ? '10px' : '30px')};
  display: inline-block;
  height: 60px;
  position: fixed;
  right: ${({ previewMode }) => (previewMode ? '10px' : '30px')};
  width: 60px;
  z-index: ${({ previewMode }) => (previewMode ? '1000' : 'auto')};

  &:hover {
    cursor: pointer;
  }
`;

export const SUnreadMessages = styled.span<{ showPulseEffect: boolean }>`
  animation: ${({ showPulseEffect }) => (showPulseEffect ? badgePulse : 'none')}
    2s infinite;
  align-items: center;
  background-color: ${colors.COLOR_RED_700};
  border-radius: 50%;
  border: 1px solid ${colors.COLOR_RED_800};
  box-sizing: border-box;
  color: ${colors.COLOR_WHITE};
  display: flex;
  font-size: 12px;
  height: 22px;
  justify-content: center;
  position: absolute;
  right: -3px;
  top: -3px;
  width: 22px;

  &::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 100%;
    height: 100%;
    background: #da344b;
    border-radius: 50%;
    transform: translate(-50%, -50%);
    animation: ${({ showPulseEffect }) =>
        showPulseEffect ? badgeRipple : 'none'}
      2s infinite;
    z-index: -1;
  }

  &::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 100%;
    height: 100%;
    background: #da344b;
    border-radius: 50%;
    transform: translate(-50%, -50%);
    animation: ${({ showPulseEffect }) =>
        showPulseEffect ? badgeRipple : 'none'}
      2s infinite 0.5s;
    z-index: -1;
  }
`;

export const SImage = styled.img`
  display: inline-block;
  height: 60px;
  left: 0;
  object-fit: contain;
  position: absolute;
  top: 0;
  width: 60px;
`;
